import { toFixedValue } from "../common";

export const productOnChangeHandler = (
  e,
  setInvoiceDetails,
  invoiceDetails,
  index,
  isStateSame,
  appSettings
) => {
  const { name } = e.target;
  const discountType = appSettings?.discType === "Amount" ? true : false;
  if (name === "qty") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? item.discPer
          : (item.discPer * Number(e.target.value) * item.rate) / 100;
        console.log("calculatedDiscount-qty,", calculatedDiscount);
        let disCountAmount = Math.max(
          Number(e.target.value) * item.rate - calculatedDiscount,
          0
        );
        return index === innerIndex
          ? {
            ...item,
            qty: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "rate") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? item.discPer
          : (item.discPer * Number(e.target.value) * item.qty) / 100;
        console.log("calculatedDiscount-rate,", calculatedDiscount);
        let disCountAmount = Math.max(
          Number(e.target.value) * item.qty - calculatedDiscount,
          0
        );
        return index === innerIndex
          ? {
            ...item,
            rate: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "unitId") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            unitId: Number(e.target.value),
          }
          : item;
      })
    );
  } else if (name === "discPer") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        let calculatedDiscount = discountType
          ? Number(e.target.value)
          : discountType
            ? Number(e.target.value)
            : (Number(e.target.value) * item.rate * item.qty) / 100;
        console.log("calculatedDiscount-discPer,", calculatedDiscount);
        let disCountAmount = item.rate * item.qty - calculatedDiscount;
        return index === innerIndex
          ? {
            ...item,
            discPer: Number(e.target.value),
            discAmount: toFixedValue(disCountAmount),
            cgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.cgst / 100))
              : 0,
            sgstAmount: isStateSame
              ? toFixedValue(disCountAmount * (item.sgst / 100))
              : 0,
            igstAmount: isStateSame
              ? 0
              : toFixedValue(disCountAmount * (item.igst / 100)),
          }
          : item;
      })
    );
  } else if (name === "cgst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            cgst: Number(e.target.value),
            cgstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            igst: 0,
            igstAmount: 0,
          }
          : item;
      })
    );
  } else if (name === "sgst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        return index === innerIndex
          ? {
            ...item,
            sgst: Number(e.target.value),
            sgstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            igst: 0,
            igstAmount: 0,
          }
          : item;
      })
    );
  } else if (name === "igst") {
    setInvoiceDetails(
      invoiceDetails.map((item, innerIndex) => {
        // let calculatedDiscount = (Number(e.target.value) * item.discAmount) / 100
        // let disCountAmount = item.discAmount - calculatedDiscount
        return index === innerIndex
          ? {
            ...item,
            igst: Number(e.target.value),
            igstAmount: toFixedValue(
              (Number(e.target.value) * item.discAmount) / 100
            ),
            cgst: 0,
            sgst: 0,
            cgstAmount: 0,
            sgstAmount: 0,
          }
          : item;
      })
    );
  }
};
